import { render, staticRenderFns } from "./SimpleNotificationListener.vue?vue&type=template&id=da330bc0&"
import script from "./SimpleNotificationListener.vue?vue&type=script&lang=js&"
export * from "./SimpleNotificationListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports